import {createContext, useContext, useState} from "react";
import {useAuth} from "./AuthContext";
import jwt_decode from "jwt-decode";
const AccountContext = createContext();
export const AccountProvider = ({ children }) => {
    const [language, setLanguage] = useState("gr");
    const [userData, setUserData] = useState({
        id: -1,
        username: "",
        email: "",
    });
    const [chosenProgramName, setChosenProgramName] = useState("");
    const [migrateFromCancellation, setMigrateFromCancellation] = useState(false);

    const clearSessionCoupon = () => {
        if (sessionStorage.getItem("discount-coupon")) {
            sessionStorage.removeItem("discount-coupon");
        }
    };


    const {authData} = useAuth();
    const [analyticsEvProductConversion, setAnalyticsEvProductConvertion] = useState(null)
    const setupAnalyticsEvProductConvertion = (newProductData) =>{
        let analyticsObject;
        if(authData.email !== null){
            analyticsObject = {
                email: authData.email,
                path: "upgrade",
                initial_sku_name: authData?.productName,
                initial_sku_id: authData?.pricePointHandle,
                initial_prod_attribute: authData?.prodAttribute,
                initial_promotion_id: authData?.promotionId,
                initial_promotion_name: authData?.promotionName,
                initial_price: authData?.price,
                initial_price_with_tax: authData?.priceWithTax,

                new_sku_name: newProductData?.skuName,
                new_sku_id: newProductData?.skuId,
                new_prod_attribute: newProductData?.prodAttribute,
                new_promotion_id: newProductData?.promotionId,
                new_promotion_name: newProductData?.promotionName,
                new_price: newProductData?.price,
                new_price_with_tax: newProductData?.priceWithTax
            };
            setAnalyticsEvProductConvertion(analyticsObject);
        }else{
            analyticsObject = {
                email: `${jwt_decode(JSON.parse(sessionStorage.getItem("kc_action")).token).email}`,
                path: "new",

                new_sku_name: newProductData?.skuName,
                new_sku_id: newProductData?.skuId,
                new_prod_attribute: newProductData?.prodAttribute,
                new_promotion_id: newProductData?.promotionId,
                new_promotion_name: newProductData?.promotionName,
                new_price: newProductData?.price,
                new_price_with_tax: newProductData?.priceWithTax
            };
            setAnalyticsEvProductConvertion(analyticsObject);
        }
        return analyticsObject;
    }

    const [analyticsAddonProductConversion, setAnalyticsAddonProductConvertion] = useState(null)
    const setupAnalyticsAddonProductConvertion = (newProductData) =>{
        let analyticsObject;
        if(authData.email !== null){
            analyticsObject = {
                email: authData.email,
                path: "new",
                new_sku_name: newProductData?.skuName,
                new_sku_id: newProductData?.skuId,
                new_prod_attribute: newProductData?.prodAttribute,
                new_price: newProductData?.price,
                new_price_with_tax: newProductData?.priceWithTax
            };
        }
        else {
            analyticsObject = {
                email: `${jwt_decode(JSON.parse(sessionStorage.getItem("kc_action")).token).email}`,
                path: "new",
                new_sku_name: newProductData?.skuName,
                new_sku_id: newProductData?.skuId,
                new_prod_attribute: newProductData?.prodAttribute,
                new_price: newProductData?.price,
                new_price_with_tax: newProductData?.priceWithTax
            };
        }
        setAnalyticsAddonProductConvertion(analyticsObject);
        return analyticsObject;
    }

    return (
        <AccountContext.Provider
            value={{
                language, setLanguage,
                userData, setUserData,
                chosenProgramName, setChosenProgramName,
                migrateFromCancellation, setMigrateFromCancellation,
                clearSessionCoupon,
                analyticsEvProductConversion, setupAnalyticsEvProductConvertion,
                analyticsAddonProductConversion, setupAnalyticsAddonProductConvertion,
            }}>
            {children}
        </AccountContext.Provider>
    )
}

export const useAccount = () => useContext(AccountContext);
